import React, { useState, useEffect } from 'react'
import { Button } from 'reactstrap'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Helmet } from 'react-helmet-async'
import { geoActions } from '../../redux/actions'
import { currentUser } from '../../redux/reducers/user.reducers'
import { pvtService } from '../../services'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import PVTNotSupportOSModal from '../../components/Modal/PVTNotSupportOSModal/PVTNotSupportOSModal'
import { CheckInput } from '../../components/Input'
import Loader from '../../components/Loader/Loader'
import Error from '../../components/Error/Error'

import './DownloadPVT.scss'

const DownloadPVT = ({ intl, getCountry, securityBlockedError, securityBlockedMessage }) => {
  const [check, setCheck] = useState(false)
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = useState(false)

  useEffect(() => {
    getCountry()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const toggleConfirm = () => {
    setCheck(!check)
    setError(false)
  }
  const toggleModal = () => {
    setModal(!modal)
  }

  const validateForm = () => {
    if (!check) {
      setError(true)
    } else {
      setLoading(true)
      setError(false)
      pvtService
        .downloadPvtFile()
        .catch(e => {
          console.error('PVT download error:', e)
          if (e && e.message === 'error.pvt.unsupportOS') {
            setModal(true)
          } else {
            setError(true)
          }
        })
        .finally(() => setLoading(false))
    }
  }

  const label = intl.formatMessage({ id: 'page.activationPage.title.heroTitle' })

  if (securityBlockedError) {
    return (
      <Error message={securityBlockedMessage} dontShowSupport header="global.label.attention" />
    )
  }

  return (
    <div className="container mt-5 mb-5" aria-labelledby="download-pvt-page-title">
      <PVTNotSupportOSModal modal={modal} toggleModal={toggleModal} />
      <Helmet>
        <title>{label}</title>
      </Helmet>
      <h1 className="page-title" id="download-pvt-page-title">
        <FormattedMessage id="page.pvtPage.title.heroTitle" />
      </h1>
      <h4>
        <FormattedMessage id="page.pvtPage.title.description" />
      </h4>
      <p>
        <FormattedMessage id="page.pvtPage.title.note" />
      </p>
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <div className="card pvt-card mb-4">
            <div className="card-body">
              <h4>
                <FormattedMessage id="global.pageTitles.terms" />
                <FormattedMessage id="footer.general.privacyPolicyLabel" />
              </h4>
              <small>
                <p>
                  <FormattedMessage id="page.pvtPage.acceptanceDisclaimer.text" />
                </p>
              </small>
            </div>
          </div>
          <div className="my-3">
            <CheckInput
              name="terms"
              checked={check}
              label="page.registrationPage.global.registrationAccept"
              onChange={toggleConfirm}
              aria-required
              aria-checked={check}
            />
          </div>
          <div className="mb-3">
            <FormattedMessage containerClass="mb-2" id="page.pvtPage.timeSensitiveDownload.text" />
          </div>
          {error && (
            <div className="form-field-validation-error-message" role="alert">
              <FormattedMessage id="error.global.acceptance" />
            </div>
          )}
          {loading ? (
            <Loader />
          ) : (
            <Button
              name="downloadPvtSubmitBtn"
              type="submit"
              outline
              color="dark"
              block
              onClick={validateForm}
              aria-disabled={loading}
              aria-describedby={error ? 'acceptance-error-message' : undefined}
            >
              <FormattedMessage id="global.label.downloadPVT" />
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  user: currentUser(state),
  securityBlockedError: state.userReducers.securityBlockedError,
  securityBlockedMessage: state.userReducers.securityBlockedMessage,
})

const mapDispatchToProps = dispatch => ({
  getCountry: () => dispatch(geoActions.getCountry()),
})

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(DownloadPVT))
